import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";


const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 340px;
  @media (max-width: 768px) {
    margin-top: 100px;
    max-width: 100%;
  }
`;

const Card = styled(GatsbyImage)`
  width: 177px;
  height: 177px;
  border-radius: 16px;
`;

const Title = styled.div`
  font-size: 22px;
  line-height: 33px;
  margin-top: 62px;
  text-align: center;
  max-width: 275px;
  color: #FFFFFF;
  @media (max-width: 768px) {
    margin-top: 27px;
  }
`;

const Text = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 27px;
  margin-top: 33px;
  text-align: center;

  color: #FFFFFF;
  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

const Cards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 270px;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 132px;
  }
`;

const CardsAchives = ({ data }) => {

  return (
    <Cards>
      {data.map((item, index) => {
        const img = getImage(item.image.localFile);
        return (
          <Container key={index}>
            <Card image={img} alt={item.title + "-image"} />
            <Title>{item.title}</Title>
            <Text>{item.description}</Text>
          </Container>
        );
      })}

    </Cards>
  );
};

export default CardsAchives;
